module.exports = __webpack_public_path__ + "media/activity-level/puppy-fairly-active-0d501048.svg";